import { usePoiImageCaptionMutation, SelectedPointOfInterestDocument } from '@/__generated__/graphql';

export function usePoiAttachmentCaption() {
  const [poiImageCaption, { data, loading, error }] = usePoiImageCaptionMutation();

  const updatePoiAttachmentCaption = async (
    pointOfInterestId: string,
    uuid: string,
    poiAttachmentId: string,
    caption: string
  ) => {
    return poiImageCaption({
      variables: {
        input: {
          pointOfInterestId,
          uuid,
          poiAttachmentId,
          caption,
          lastModifiedFor: 'Update attachment caption',
        },
      },
      refetchQueries: [SelectedPointOfInterestDocument],
    });
  };

  return { updatePoiAttachmentCaption, data, loading, error };
}
